export const exterior_view01ImageOptions = {
  angle: 'exterior_view01',
  staticOptions: {
    HullTreatment: 1,
    BowSpritRailing: 1,
    BowSpritLadder: 1,
    Deck: 1,
    TeakOnSideDecks: 1,
    TeakOnCoachroof: 1,
    MastAndBoom: 1,
    Sprayhood: 1
  },
  mattes: [
    {
      option: 'HullTreatment',
      dependency: null
    },
    {
      option: 'BowSpritRailing',
      dependency: null
    },
    {
      option: 'BowSpritLadder',
      dependency: null
    },
    {
      option: 'Deck',
      dependency: 'Wheel'
    },
    {
      option: 'TeakOnSideDecks',
      dependency: 'Deck'
    },
    {
      option: 'TeakOnCoachroof',
      dependency: 'Deck'
    },
    {
      option: 'MastAndBoom',
      dependency: null
    },
    {
      option: 'Sprayhood',
      dependency: 'Deck'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/X49MK2/views/exterior_view01.js